import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from 'services/logging.service';

@Injectable({
	providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

	constructor(private logger: LoggingService) { }
	handleError(error: any): void {
		console.error(error);
		if (String(error).indexOf('@azure/msal-angular') > -1)
			this.logger.onError.next(new Error('Login failed, check credentials and that popups are allowed'));
		this.logger.logException(error);
	}
}
